import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController, ToastController } from 'ionic-angular';

import { globalDefines } from '../../app/app.constants';
import { CheckProvider } from '../../providers/check/check';
import { UserProvider } from '../../providers/user/user';


@IonicPage()
@Component({
  selector: 'page-history',
  templateUrl: 'history.html',
})
export class HistoryPage {

  checks;
  checksSubscription;
  date;
  selectedUser;
  users;

  workedTime;
  
  constructor(
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController, 
    public navCtrl: NavController, 
    public navParams: NavParams,
    public toastCtrl: ToastController, 
    public checkProvider: CheckProvider,
    public userProvider: UserProvider
  ) {
    this.users = userProvider.getUserNames();
  }

  ionViewWillUnload() {
    if(this.checksSubscription && !this.checksSubscription.closed) this.checksSubscription.unsubscribe()
  }

  addCheck() {
    this.navCtrl.push('CheckInfoPage', { mode: 'add' });
  }

  editCheck(check) {
    console.log(check)
    this.navCtrl.push('CheckInfoPage', { mode: 'edit', check: check })
  }

  infoCheck(check) {
    this.navCtrl.push('CheckInfoPage', { mode: 'info', check: check });
  }

  loadChecks() {
    if(this.selectedUser) {
      if(this.date == null) this.date = new Date().toISOString();

      let loading = this.loadingCtrl.create();
      loading.present();

      console.log(new Date(this.date))

      this.checksSubscription = this.checkProvider.getUserChecks(new Date(this.date), this.selectedUser).subscribe(checks => {
        this.checks = checks;

        let workedMillis = this.calculateTime(this.checks.slice().reverse()).total
        this.workedTime = workedMillis > 0 ? msToTime(workedMillis) : null;
      })
      
      loading.dismiss();
    }
  }

  removeCheck(check) {
    let confirm = this.alertCtrl.create({
      title: 'Eliminar un fichaje',
      message: '¿Seguro que quiere eliminarlo?',
      buttons: [
        {
          text: 'No',
          handler: () => {}
        },
        {
          text: 'Sí',
          handler: () => {
            console.log(this.selectedUser);

            this.checkProvider.remove(check.key, this.selectedUser).then(() => {
              this.showMessage('Fichaje eliminado')
            });
          }
        }
      ]
    });
    confirm.present();
  }

  ubication(check) {
    if(check.coords) this.navCtrl.push('MapPage', { mode: 'check', check: check });
    else this.showMessage(`Este fichaje se ha añadido manualmente o mediante de un fichador.`);
  }
  
  private calculateTime(dayChecks: any) {
    if(dayChecks.length == 0) 
      return { error: -1, total: 0, pauses: 0 };

    else {

      let date, dateToday, newTimestamp;

      date = new Date(dayChecks[0].timestamp).toDateString();
      dateToday = new Date().toDateString();

      // Si és el dia actual, comprovar que no estigui treballant encara
      if(date == dateToday) {
        let newTimestamp;

        // Afegir una sortida simbòlica si encara està en entrada
        if(dayChecks[dayChecks.length-1].type == 'Entrada' || dayChecks[dayChecks.length-1].type == 'Reanudar') {
          newTimestamp = new Date().getTime();
    
          dayChecks.push({ type: 'Salida', timestamp: newTimestamp, delay: 0 });
        }
      }
      
      // Afegir una entrada simbòlica en primera posició si no existeix
      if(dayChecks[0].type != 'Entrada') {
        date = new Date(dayChecks[0].timestamp);
        newTimestamp = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0).getTime();
  
        dayChecks.unshift({ type: 'Entrada', timestamp: newTimestamp, delay: 0 });
      }
  
      // Afegir una sortida simbòlica en primera posició si no existeix
      if(dayChecks[dayChecks.length-1].type != 'Salida') {
        date = new Date(dayChecks[0].timestamp);
        newTimestamp = new Date(date.getFullYear(), date.getMonth(), date.getDate()+1, 0, 0, 0, 0).getTime();
  
        dayChecks.push({ type: 'Salida', timestamp: newTimestamp, delay: 0 });
      }
  
      // Càlcul de temps treballat
      let total = 0;
      let pauses = 0;
      let begin, end, range;
      let pauseBegin, pauseEnd, pauseRange;
      let state;

      while(dayChecks.length > 0) {

        if(dayChecks[0].type == 'Entrada') {
          begin = dayChecks[0].timestamp;
          state = 'treballant';
        }

        else if(dayChecks[0].type == 'Reanudar') {
          begin = dayChecks[0].timestamp;
          state = 'treballant';

          pauseEnd = dayChecks[0].timestamp
          pauseRange = pauseEnd - pauseBegin;
          pauses += pauseRange;
        }

        else if(dayChecks[0].type == 'Pausa') {
          end = dayChecks[0].timestamp;
          range = end - begin;
          
          if(state == 'treballant') {
            total += range;
          }
          
          state = 'descansant';
          pauseBegin = dayChecks[0].timestamp;
          console.log('Pausa', pauseBegin);
        }
        
        else {
          end = dayChecks[0].timestamp;
          range = end - begin;
          
          if(state == 'treballant') {
            total += range;
          }
          state = 'descansant';
        }

        dayChecks.shift();
      }

      return { error: 0, total: total, pauses: pauses };
    }
  }

  private showMessage(message: string) {
    this.toastCtrl.create({message: message, duration: globalDefines.defaultToastDuration}).present();
  }
}

/**
 * Obtenir un string amb hores, minuts i segons a partir de uns milisegons donats.
 * 
 * @param ms Milisegons
 */
function msToTime(ms): string {

  ms = Math.abs(ms);

  var h, m, s;
  s = Math.floor(ms / 1000);
  m = Math.floor(s / 60);
  s = s % 60;
  h = Math.floor(m / 60);
  m = m % 60;

  var result = s + ' seg';
  if(m > 0) result = m + ' min, ' + result;
  if(h > 0) result = h + ' h, ' + result;

  return result;
}


// WEBPACK FOOTER //
// ./src/pages/history/history.ts